// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__HDfwV","buttons":"SendReceipts_buttons__2KKtF","email":"SendReceipts_email__2W_m4","bookApptTitle":"SendReceipts_bookApptTitle__1NZ0X"};